import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { tlsCertificateLevel } from 'appConstants';
import { useTranslation } from 'react-i18next';

const TLSCertificateLevel: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { t: tForm } = useTranslation('form');

	const tlsCertificateLevelName = tForm(
		tlsCertificateLevel.find((el) => el.id === restaurantForFullInfo?.tlsCertificateLevel)?.name || '',
	);

	return (
		<>
			{restaurantForFullInfo?.tlsCertificateLevel !== 'None' && (
				<FullInfoField label="settingsLabel" value={tlsCertificateLevelName} />
			)}
		</>
	);
};

export default TLSCertificateLevel;
